import React from 'react';
import { Typography, Card, Space, Divider } from 'antd';

const { Title, Paragraph, Text } = Typography;

export const TermsAndConditions: React.FC = () => {
  return (
    <Card style={{ maxWidth: 800, margin: '0 auto' }}>
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <Title level={2} style={{ textAlign: 'center', marginBottom: 24 }}>
          StageNote Terms and Conditions
        </Title>
        
        <Paragraph>
          <Text strong>Last Updated: {new Date().toLocaleDateString()}</Text>
        </Paragraph>

        <Paragraph>
          Welcome to StageNote! These Terms and Conditions (&quot;Terms&quot;) govern your use of our platform 
          as a music tutor. By registering and using our services, you agree to be bound by these Terms.
        </Paragraph>

        <Divider />

        <Title level={3}>1. Tutor Responsibilities</Title>
        <Paragraph>
          <ul>
            <li>Provide high-quality music instruction to students</li>
            <li>Maintain professional conduct at all times</li>
            <li>Be punctual and reliable for scheduled lessons</li>
            <li>Communicate clearly and respectfully with students and parents</li>
            <li>Keep accurate records of lessons and student progress</li>
          </ul>
        </Paragraph>

        <Title level={3}>2. Platform Usage</Title>
        <Paragraph>
          <ul>
            <li>Use the platform only for legitimate tutoring activities</li>
            <li>Maintain the confidentiality of student information</li>
            <li>Report any technical issues or concerns promptly</li>
            <li>Keep your profile information accurate and up-to-date</li>
          </ul>
        </Paragraph>

        <Title level={3}>3. Payment and Fees</Title>
        <Paragraph>
          <ul>
            <li>StageNote charges a platform fee of 5% on all lesson payments</li>
            <li>Payments are processed securely through our payment partners</li>
            <li>Tutors are responsible for their own tax obligations</li>
            <li>Refund policies must be clearly communicated to students</li>
          </ul>
        </Paragraph>

        <Title level={3}>4. Lesson Policies</Title>
        <Paragraph>
          <ul>
            <li>Cancellations must be made at least 24 hours in advance</li>
            <li>Make-up lessons should be offered for tutor cancellations</li>
            <li>Maintain appropriate boundaries with students</li>
            <li>Ensure a safe and conducive learning environment</li>
          </ul>
        </Paragraph>

        <Title level={3}>5. Intellectual Property</Title>
        <Paragraph>
          You retain ownership of your teaching materials and methods. However, you grant StageNote 
          a limited license to use your profile information and testimonials for marketing purposes.
        </Paragraph>

        <Title level={3}>6. Privacy and Data Protection</Title>
        <Paragraph>
          We are committed to protecting your privacy and that of your students. All personal data 
          is handled in accordance with our Privacy Policy and applicable data protection laws.
        </Paragraph>

        <Title level={3}>7. Account Termination</Title>
        <Paragraph>
          Either party may terminate this agreement with 30 days&apos; notice. StageNote reserves the 
          right to immediately suspend accounts for violations of these Terms.
        </Paragraph>

        <Title level={3}>8. Limitation of Liability</Title>
        <Paragraph>
          StageNote provides the platform &quot;as is&quot; and is not liable for any indirect, incidental, 
          or consequential damages arising from your use of the service.
        </Paragraph>

        <Title level={3}>9. Dispute Resolution</Title>
        <Paragraph>
          Any disputes will be resolved through binding arbitration in accordance with the rules 
          of the American Arbitration Association.
        </Paragraph>

        <Title level={3}>10. Changes to Terms</Title>
        <Paragraph>
          We may update these Terms from time to time. Continued use of the platform after changes 
          constitutes acceptance of the updated Terms.
        </Paragraph>

        <Divider />

        <Paragraph>
          <Text strong>
            By checking the acceptance box during registration, you acknowledge that you have read, 
            understood, and agree to be bound by these Terms and Conditions.
          </Text>
        </Paragraph>

        <Paragraph>
          If you have any questions about these Terms, please contact us at{' '}
          <Text code>support@stagenote.ai</Text>
        </Paragraph>
      </Space>
    </Card>
  );
};

export default TermsAndConditions; 